import PropTypes from 'prop-types'

export const SettingItem = ({ label, description, children, disabled = false, className = '' }) => (
  <div
    className={`flex flex-col sm:flex-row sm:items-center sm:justify-between py-4 border-b border-dark-border last:border-b-0 ${
      disabled ? 'opacity-50' : ''
    } ${className}`}
  >
    <div className="mb-3 sm:mb-0 sm:mr-4 flex-1">
      <h3 className="text-white font-medium">{label}</h3>
      {description && <p className="text-gray-400 text-sm mt-1">{description}</p>}
    </div>
    <div className="flex-shrink-0">{children}</div>
  </div>
)

SettingItem.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default SettingItem
